import React from "react";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type LinkedinPostErrorNotificationProps = {
  notification: CHQ.NotificationLinkedinPostError;
  tabIndex?: number;
};

const LinkedinPostErrorNotification: React.FC<LinkedinPostErrorNotificationProps> = ({
  notification: { entity }
}) => {
  const { profile } = useProfile();

  return (
    <NotificationBody actor={entity || profile}>
      {" "}
      <Trans>
        LinkedIn service failed, please try again
      </Trans>
      <br />
    </NotificationBody>
  );
};

export default LinkedinPostErrorNotification;
